<template>
  <keep-alive>
    <transition name="FadeIn">
      <div
        class="Popup"
        v-if="forms.projectAboutPopup.opened"
        @click.self="
          managePopupState({ popup: 'projectAboutPopup', _state: false })
        "
      >
        <div class="Popup__inner">
          <div
            class="Popup__close"
            @click="
              managePopupState({ popup: 'projectAboutPopup', _state: false })
            "
          >
            <span aria-label="Close Popup">&times;</span>
          </div>
          <div class="Popup__content">
            <div class="Popup__caption">
              <h2>{{ $t("HELP_CENTER") }}</h2>
            </div>
            <div class="Popup__video">
              <video
                controls="controls"
                poster="@/assets/images/15MGKlq2K_DhuqHGMT0M9H.svg"
              >
                <source
                  src="@/assets/media/55e790ff-904b-4a27-86cb-ee20173a0518.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
            <div class="Popup__text">
              <p>
                <i18n path="VUE.ABOUT&FORM">
                  <template #strong>
                    <strong>{{ $t("HELP_CENTER") }}</strong>
                  </template>
                </i18n>
              </p>
              <p>{{ $t("VUE.ABOUT_TEXT_2") }}</p>
              <p>{{ $t("VUE.ABOUT_TEXT_3") }}</p>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </keep-alive>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";

export default {
  name: "ProjectAbout",
  methods: {
    ...mapMutations(["managePopupState"])
  },
  computed: {
    ...mapGetters(["forms"])
  }
};
</script>
